var r=function(){return Array.isArray||function(r){return r&&"number"==typeof r.length}}();export{r as isArray};
